module.exports = __webpack_public_path__ + "static/img/2-3.3d0ea76.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/2-3.png
// module id = ZvUl
// module chunks = 1